export function useFileDownload(blob, filename) {
  const file = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = file;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
